// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"eaf4b72b","703":"51498fc1"}[chunkId] + ".chunk.js";
};